import React from "react";
import dashboard from "../../../../assets/Images/dashboard.png";
import { FaHandshake, FaPenFancy, FaShieldAlt } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const DashboardSection = () => {
    const { t } = useTranslation("translation");

    return (
        <section className="dashboard-showcase-section">
            <div className="guest-container">

                {/* Heading Section */}
                <div className="guest-section-header">
                    <h2 className="heading-primary">
                        {t("dashboard.heading")}
                    </h2>
                    <p className="text-lead">
                        {t("dashboard.subHeading")}
                    </p>
                </div>

                {/* Grid Layout */}
                <div className="dashboard-grid">

                    {/* Left Content */}
                    <div className="benefits-list">
                        <div className="benefit-item">
                            <div className="benefit-icon-wrapper">
                                <FaHandshake size={30} />
                            </div>
                            <div className="benefit-content">
                                <p className="text-body">
                                    {t("dashboard.point1")} <span className="text-highlight">70%</span>
                                </p>
                            </div>
                        </div>

                        <div className="benefit-item">
                            <div className="benefit-icon-wrapper">
                                <FaPenFancy size={30} />
                            </div>
                            <div className="benefit-content">
                                <p className="text-body">
                                    {t("dashboard.point2")}
                                </p>
                            </div>
                        </div>

                        <div className="benefit-item">
                            <div className="benefit-icon-wrapper">
                                <FaShieldAlt size={30} />
                            </div>
                            <div className="benefit-content">
                                <p className="text-body">
                                    {t("dashboard.point3")}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Right Dashboard Image */}
                    <div className="dashboard-image-wrapper">
                        <div className="dashboard-mockup-container">
                            <div className="dashboard-mockup">
                                <img
                                    src={dashboard}
                                    alt={t("dashboard.altText")}
                                    className="dodashboard-image"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DashboardSection;
